module.exports = __webpack_public_path__ + "img/开启历史文件.2c653b89.svg";